import React, { useState, useEffect, useContext, useRef } from 'react';
import { UserContext } from '../../../context/provider/UserProvider';
import { useHistory } from "react-router-dom";
import { useCerrarSesion } from '../../../hooks/useCerrarSesion';
import { Timer } from './Timer';
import LogoAbexa2018 from '../../../assets/images/LogoAbexa2018.png'
import Logobeex from '../../../assets/images/Logobeex.fw.png'
import { Slide } from '../../components/utils/Slide';

export const Header = ({openMenu}) => {

    const dropDown = useRef()
    const { stateUser, signOut } = useContext(UserContext)

    const slideImages = [ LogoAbexa2018, Logobeex ];

    const singOutSession = () => {
        cerrarSesion()
    }

    const cerrarSesion = async () => {
        const urlLogout = process.env.REACT_APP_WSO2IS_LOGOUT
        const queryParameters = new URLSearchParams({
            id_token_hint: stateUser.id_token,
            post_logout_redirect_uri: process.env.REACT_APP_REDIRECT_URI,
            state: "logout_success",
            id_carga: Date.now()
        });
        window.location.href = `${urlLogout}/logout?${queryParameters}`;
    }

    const toggleUser = () => {  
        const isClosed = dropDown.current.classList.contains('hidden')
        isClosed && dropDown.current.classList.remove('hidden')
        !isClosed && dropDown.current.classList.add('hidden')
    }

    return (    
        <>
            <div className="header">
                <nav>
                    <div className="width-full px-4 lg:px-2">
                        <div className="relative flex items-center justify-between h-16">
                            <div className="flex items-center hidden lg:flex w-[110px]">
                            <button onClick={openMenu} type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
                                <i className="fas fa-bars text-[20px]"></i>
                            </button>
                        </div>

                        <div className="flex-1 flex items-stretch justify-start lg:items-center lg:justify-center">
                            <div className="flex-shrink-0 flex justify-center items-center w-[250px]" >
                                
                                <Slide images={slideImages} />

                            </div>
                        </div>

                        <div className=" lg:relative w-[200px] h-[100%] lg:w-[100px] flex items-center lg:right-0 inset-auto ml-6">
                            <div className='top-9 lg: right-[160px] lg:right-[2px] bottom-[1px] lg:top-5' >
                                <Timer className=' lg:right-[2px] lg:top-1 top-1 right-[1px]'></Timer>
                                <button onClick={() => toggleUser()} className="lg:right-[1px]  right-[75px] lg:top-5 absolute bottom-0 px-1 py-1 hover:bg-blue-600 rounded">
                                    <i className='hidden lg:flex fa fa-user px-1 text-xl'></i>
                                    <span className="lg:hidden lg:text-[15px] text-[18px]">{ stateUser?.nomUsuario?.toLowerCase() }</span>
                                </button>   
                            </div>
                        </div>

                        <div ref={dropDown} className="absolute top-[66px] right-0 hidden z-50 w-44 bg-white rounded divide-y divide-blue-100 shadow dark:bg-blue-800">
                            <ul className="py-1 text-sm text-white-700 dark:text-white-900" aria-labelledby="dropdownButton">
                                <li className="block py-2 px-4 hover:bg-blue-100 dark:hover:bg-blue-600 dark:hover:text-white cursor-pointer">Cambiar clave</li>
                            </ul>
                            <ul className="py-1 text-sm text-white-700 dark:text-white-900" aria-labelledby="dropdownButton">
                                <li onClick={() => singOutSession()}  className="block py-2 px-4 hover:bg-blue-100 dark:hover:bg-blue-600 dark:hover:text-white cursor-pointer">Cerrar Sesión</li>
                            </ul>
                        </div>
                    </div>
                    </div>
                </nav>
            </div>
        </>
    )
}